<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="commitments" slot-scope="{ item }">
                {{ !!item.commitments ? 'Si' : 'No' }}
            </template>
            <template slot="commitment_approved" slot-scope="{ item }">
                {{ !!item.commitment_approval_date ? 'Si' : 'No' }}
            </template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn
                    size="sm"
                    title="Descargar Reporte"
                    block
                    variant="primary"
                    @click="downloadQualificationReport(item)"
                >
                    <i class="fa fa-download" aria-hidden="true"></i>
                    Descargar
                </b-btn>
            </template>
            <!-- <template slot="actions" slot-scope="{ item }">
                <b-row>
                    <b-col
                        cols="12"
                        v-if="item.performance_evaluation.administrative"
                    >
                        <b-btn
                            size="sm"
                            :disabled="!item.commitment_approval_date"
                            title="Descargar Reporte"
                            block
                            variant="primary"
                            @click="downloadQualificationReport(item)"
                        >
                            <i class="fa fa-download" aria-hidden="true"></i>
                            Descargar
                        </b-btn>
                    </b-col>
                    <b-col cols="12" v-else>
                        <b-btn
                            size="sm"
                            :disabled="!item.commitments"
                            title="Descargar Reporte"
                            block
                            variant="primary"
                            @click="downloadQualificationReport(item)"
                        >
                            <i class="fa fa-download" aria-hidden="true"></i>
                            Descargar
                        </b-btn>
                    </b-col>
                </b-row>
            </template> -->
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [Array, Object],
            default: '',
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    data: () => ({
        fields,
        saving: false,
    }),
    methods: {
        downloadQualificationReport(evaluationEmployee) {
            window.open(
                'web/v1/performance-evaluations/qualification-report?' +
                    'evaluationId' +
                    '=' +
                    evaluationEmployee.performance_evaluation_id +
                    '&' +
                    'evaluatedId' +
                    '=' +
                    evaluationEmployee.evaluated.id,
                '_blank'
            )
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'evaluated.name',
        label: 'Nombre',
    },
    {
        key: 'commitments',
        label: 'Compromisos',
    },
    {
        key: 'commitment_approved',
        label: 'Aprobados',
    },
    {
        key: 'actions',
        label: 'Reporte',
    },
]
</script>

